import {FC} from "react";
import {ReportPage, ReportSalesInGraphSearchPanel} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {searchReportItemsDifferentInVatCalculation,} from "../../../serviceBroker/transationReportApiServiceBroker";
import {PageEnum, SalesInGraphReportSearchParamsModel} from "../../../models";

export const ReportItemsDifferentInVatCalculationPage: FC = () => {
    const initialState: SalesInGraphReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        userId: getUserId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportItemsDifferentInVatCalculation}
            searchHeader={getPageNameByPageId(PageEnum.ReportItemDifferentInVatCalculation)}
            SearchPanel={ReportSalesInGraphSearchPanel}
            formId={PageEnum.ReportItemDifferentInVatCalculation}
        />
    );
};
